<template>
  <div id="careerHistoryTab">
    <v-row>
      <v-col cols="12" class="text-center text-md-left"><h1>Career History</h1></v-col>
      <v-col cols="12">
        <v-card :loading="dataLoading">
          <v-card-text>
            <v-row>
              <v-col cols="12"><InfoBox title="Tell us a little about your Career History" /></v-col>
              <v-col cols="12">
                <v-form ref="frmRegisterSummary" v-model="valid" lazy-validation>
                  <TextAreaFieldWithAIGenerator
                    :computedOptions="
                      items?.map((item) => getDetailName(item.JobTitle) + '-' + item.JobSkills.map((skill) => getSkillName(skill)).join('-'))
                    "
                    :readonly="isHiringmanager"
                    id="CareerHistoryDescription"
                    placeholder="Describe your main area of experience, your current role, your roles to date ..."
                    showRequired
                    counter
                    :rules="[validations.required, validations.minCharDesc]"
                    v-model="careerHistorySummaryDescription"
                    outlined
                  />
                </v-form>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12" class="text-right pt-0">
                <v-btn v-if="!isHiringmanager" class="primary_btn" @click="saveCareerHistoryDescription()" :loading="loading"> Save</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card :loading="dataLoading">
          <v-card-title> Add Career History </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <InfoBox
                  title="Add Your Career History here! Include your previous relevant experience, and your current role (if currently employed)"
                />
              </v-col>
              <v-col cols="12">
                <v-btn class="primary_btn w-100" prepend-icon="mdi-plus" @click="showAddAndEdit = true">Add Career History</v-btn>
              </v-col>
            </v-row>
            <CareerHistoryList
              :isHiringmanager="isHiringmanager"
              @remove="remove"
              @edit="edit"
              :details="details"
              :skills="skills"
              :careerHistoryList="items"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card-actions class="mt-5" v-if="isAfterSignUp">
      <div class="wizard-action">
        <v-tooltip top attach>
          <template v-slot:activator="{ props }">
            <v-btn
              class="secondary_btn"
              v-bind="props"
              @click="getAllDataAndSubmit(true)"
              :disabled="submitting"
              :loading="submitting"
              prepend-icon="mdi-check"
              >Save and exit</v-btn
            >
          </template>
          <span>You can save your progress and return to the application process later</span>
        </v-tooltip>
        <div class="d-flex ga-5">
          <v-btn class="primary_btn actionButton" @click="goBack()" :disabled="loading" :loading="loading" prepend-icon="mdi-chevron-left"
            >Back</v-btn
          >
          <v-btn
            class="primary_btn actionButton"
            @click="getAllDataAndSubmit(false)"
            :disabled="submitting"
            :loading="submitting"
            append-icon="mdi-chevron-right"
            >Next</v-btn
          >
        </div>
      </div>
    </v-card-actions>
  </div>
  <v-dialog persistent v-model="showRemoveConfirm" @keydown.esc="showRemoveConfirm = false" max-width="400px">
    <confirm-dialog
      :loading="deleteLoading"
      @confirm="confirmDelete"
      @cancel="
        showRemoveConfirm = false;
        deleteLoading = false;
      "
      :message="confirmModel"
    >
    </confirm-dialog>
  </v-dialog>
  <v-dialog v-model="showSaveForLaterConfirm" max-width="500" @keydown.esc="showSaveForLaterConfirm = false" persistent>
    <confirm-dialog :loading="loading" :message="confirmModel" @confirm="saveForLator" @cancel="cancelSaving"></confirm-dialog>
  </v-dialog>
  <v-dialog v-model="showAddAndEdit" @keydown.esc="cancel" max-width="1000px" scrollable persistent>
    <CareerHistoryRegister
      :isHiringmanager="isHiringmanager"
      :sendReqeustLoading="sendReqeustLoading"
      :editingItem="editingItem"
      @cancel="cancel"
      :submitting="loading"
      @sendJobRequest="sendJobRequest"
      @scrollToElement="scrollToElement"
      :skills="skills"
      :teammemberSkills="teammemberSkills"
      @saved="saveCareerHistory"
      :isAfterSignUp="isAfterSignUp"
      :details="details"
    />
  </v-dialog>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import CareerHistories from "../../../models/CareerHistories";
import CareerHistoryRegister from "./CareerHistoryRegister.vue";
import CareerHistoryList from "./CareerHistoryList.vue";
import CareerHistoryService from "../../../services/CareerHistoryService";
import ConfirmDialog from "../../ConfirmDialog.vue";
import { ProjectMessages } from "../../../definitions/constants";
import validations from "../../../utils/validations";
import Details from "../../../models/Details";
import TextAreaFieldWithAIGenerator from "../../Fields/TextAreaFieldWithAIGenerator.vue";
import InfoBox from "../../InfoBox.vue";
import store from "@/store";

export default defineComponent({
  props: [
    "skills",
    "teammemberSkills",
    "formLoading",
    "isAfterSignUp",
    "careerHistoryDescription",
    "careerHistories",
    "submitting",
    "details",
    "selectedTeammemberModel",
    "snackbarmassage",
    "isHiringmanager",
  ],
  components: { CareerHistoryRegister, ConfirmDialog, CareerHistoryList, TextAreaFieldWithAIGenerator, InfoBox },
  data() {
    return {
      validations,
      dataLoading: false,
      valid: false,
      sendReqeustLoading: false,
      showJobRequestConfirm: false,
      selectedJob: "",
      technologies: [] as string[],
      selectedItem: {} as CareerHistories,
      showSaveForLaterConfirm: false,
      editingItem: null as CareerHistories | null,
      careerHistorySummaryDescription: "",
      itemRemoveId: -1,
      showRemoveConfirm: false,
      selectedId: null as string | null,
      loading: false,
      deleteLoading: false,
      showDialog: false,
      items: [] as CareerHistories[] | null,
      confirmModel: {
        title: ProjectMessages.removeCareerHistory,
        text: ProjectMessages.confirmation,
      },
      showAddAndEdit: false,
    };
  },
  methods: {
    getDetailName(id: string) {
      return this.details.find((item: any) => item.id == id)?.Name ?? id;
    },
    getSkillName(skillId: any) {
      var findSkill = this.skills.find((s: any) => s.id === skillId);
      if (findSkill) {
        return findSkill.Text;
      }
    },
    getAllDataAndSubmit(isForLator = false) {
      if (isForLator) {
        this.confirmModel.title = `Save Progress for Later?`;
        this.confirmModel.text =
          "You're almost ready to move on to your personalized screening experience. Are you sure you want to save your progress for later instead?";
        this.showSaveForLaterConfirm = true;
      } else {
        this.saveCareerHistoryDescription(true);
      }
    },
    sendJobRequest() {
      this.$emit("sendJobRequest");
    },
    saveForLator() {
      this.cancelSaving();
      this.saveCareerHistoryDescription(true, true);
    },
    cancelSaving() {
      this.showSaveForLaterConfirm = false;
    },
    scrollToElement(el: any) {
      this.$emit("scrollToElement", el);
    },
    goBack() {
      this.$emit("goBack", 4);
    },
    remove(item: CareerHistories): void {
      this.selectedItem = item;
      this.showRemoveConfirm = true;
    },
    async confirmDelete() {
      this.deleteLoading = true;
      if (this.selectedItem) {
        var result = await CareerHistoryService.delete(this.selectedItem.Id, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
        if (result) {
          this.editingItem = null;
          this.items = result;
          store.dispatch("showSuccessMessage", "Career history have been deleted successfully!");
        } else {
          store.dispatch("showErrorMessage", "Couldn't delete career history!");
        }
      }
      this.showRemoveConfirm = false;
      this.deleteLoading = false;
    },
    edit(item: any): void {
      this.editingItem = item;
      this.showAddAndEdit = true;
    },
    cancel(): void {
      this.editingItem = null;
      this.showAddAndEdit = false;
    },
    async saveCareerHistory(event: { model: CareerHistories; callbackMethod: any }): Promise<void> {
      this.loading = true;
      try {
        if (event.model.JobTitle) {
          var jobtitle = this.details.find(
            (c: any) =>
              c.Type == "JobTitle" &&
              (c.id === event.model.JobTitle || (c.Name && c.Name.trim().toLowerCase() === event.model.JobTitle.trim().toLowerCase()))
          );
          if (jobtitle) {
            event.model.JobTitle = jobtitle.id;
          }
        }
        var result = await CareerHistoryService.set(event.model, this.selectedTeammemberModel ? this.selectedTeammemberModel.id : "");
        if (result && result.CareerHistoryModel && result.CareerHistoryModel.length > 0) {
          this.editingItem = null;
          if (!jobtitle) {
            var mappedJobTitles = this.details.filter((c: any) => c.type === "JobTitle").map((c: any) => c.id);
            var findNewJobTitle = result.CareerHistoryModel.find((c: any) => !mappedJobTitles.includes(c.JobTitle));
            this.$emit("updateJobTitle", {
              id: findNewJobTitle?.JobTitle,
              Name: event.model.JobTitle,
              RoleId: event.model.JobRole,
              Type: "JobTitle",
            } as Details);
          }
          if (result.NewAddedSkills && result.NewAddedSkills.length > 0) {
            this.$emit("updateSkill", { newSkills: result.NewAddedSkills });
          }
          this.items = result.CareerHistoryModel as CareerHistories[];
          if (!this.isAfterSignUp) {
            if (event.model.Id) {
              store.dispatch("showSuccessMessage", "Career history have been Updated successfully!");
            } else {
              store.dispatch("showSuccessMessage", "Career history have been Added successfully!");
            }
          }
        } else if (!this.isAfterSignUp) {
          store.dispatch("showErrorMessage", "Couldn't save career history!");
        }
        this.loading = false;
        event.callbackMethod();
        this.cancelSaving();
        this.showAddAndEdit = false;
      } catch {
        store.dispatch("showErrorMessage", "Couldn't save career history!");
      } finally {
        this.loading = false;
        this.cancelSaving();
      }
    },
    async saveCareerHistoryDescription(isAfterSignUp: boolean = false, forLater = false): Promise<void> {
      var registerSummaryForm = this.$refs.frmRegisterSummary as any;
      let isValid = true;
      if (!forLater && registerSummaryForm) {
        isValid = (await (this.$refs.frmRegisterSummary as any).validate()).valid;
      }
      if (isValid) {
        this.loading = true;
        var result = await CareerHistoryService.saveCareerHistoryDescription(
          this.careerHistorySummaryDescription,
          this.selectedTeammemberModel ? this.selectedTeammemberModel.id : ""
        );
        if (result && result.length > 0) {
          this.$emit("setCareerHistoryDescriptionState", this.careerHistorySummaryDescription);
          this.editingItem = null;
          if (isAfterSignUp && !forLater) {
            this.$emit("goNext", 5);
          } else {
            store.dispatch("showSuccessMessage", "Career history description have been saved successfully!");
          }
        } else {
          store.dispatch("showErrorMessage", "Couldn't save career history description!");
        }
        this.loading = false;
      } else {
        var el = document.querySelector("#careerHistoryTab .v-messages.error--text:first-of-type");
        this.scrollToElement(el);
      }
    },
  },
  watch: {
    formLoading(newVal) {
      this.dataLoading = newVal;
    },
    careerHistoryDescription(newVal) {
      this.careerHistorySummaryDescription = newVal;
    },
    submitting(newVal) {
      this.loading = newVal;
    },
    careerHistories(newVal) {
      this.items = newVal;
    },
  },
  mounted() {
    var registerSummaryForm = this.$refs.frmRegisterSummary as any;
    if (registerSummaryForm) {
      registerSummaryForm.reset();
    }
    this.careerHistorySummaryDescription = this.careerHistoryDescription;
    this.$emit("getCareerHistories");
  },
});
</script>
